import React from 'react';
import SetProject from './SetProject';

const Jira = ({ onClose }) => <SetProject onClose={ onClose } />;

export default Jira;
